import { z } from 'zod';
export const reportPeriodSchema = z
    .enum(['month', 'ytd', 'q1', 'q2', 'q3', 'q4'])
    .describe('How much time the report covers, counted back from the report date. `month` covers that month. `ytd` covers January to that month. `q1` to `q4` each cover one calendar quarter.');
//# sourceMappingURL=reportPeriod.js.map